import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {CompanyService, LoadingSpinnerService, ToastService, UserService} from '../../services';
import {Company, IPageable, IUserRights} from '../../models/user/user';
import {ManageableUsersParams} from '../../services/user/user.service';
import {VwuiModalService} from '@bvgo-ict/vwui-angular';
import {ChangeUserModalComponent} from '../../components';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {map, take} from 'rxjs/operators';

@Component({
    selector: 'app-page-user-management',
    templateUrl: './page-user-management.component.html',
    styleUrls: ['./page-user-management.component.scss'],
    standalone: false
})
export class PageUserManagementComponent implements OnInit, OnDestroy {
    public loadingSpinnerService = inject(LoadingSpinnerService);
    private userService = inject(UserService);
    private companyService = inject(CompanyService);
    private toastService = inject(ToastService);
    private modalService = inject(VwuiModalService);


    public usersRights: IUserRights[];
    public pageable: IPageable<unknown>;
    public companies$: Promise<Company[]>;
    public filterForm = new UntypedFormGroup({
        search: new UntypedFormControl(),
        company: new UntypedFormControl()
    });
    private userParameters: ManageableUsersParams = {};
    private subscriptions: Subscription[] = [];

    ngOnInit(): void {
        this.subscriptions.push(this.filterForm.valueChanges.subscribe(filterValues => {
            this.userParameters.userSearch = filterValues.search;
            this.userParameters.company = filterValues.company;
            this.loadUserPage();
        }));
        this.loadUsers();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.subscriptions.length = 0;
    }

    loadUsers(): void {
        this.loadingSpinnerService.show();
        this.companies$ = this.companyService.getCompanies();
        this.loadUserPage();
    }

    private loadUserPage() {
        this.userService.manageableUsers(this.userParameters)
            .then((userPage) => {
                this.pageable = userPage;
                this.usersRights = userPage.content.map((ui) => ui);

                // Reset the user info to make sure the roles are kept in sync
                this.userService.resetUserInfo();
            })
            .catch((error) => {
                this.toastService.openError(error.status, 'Oops!');
            })
            .finally(() => {
                this.loadingSpinnerService.hide();
            });
    }

    changePage($event: CustomEvent<number>): void {
        if ($event.detail && $event.detail <= this.pageable.totalPages) {
            this.userParameters.page = $event.detail - 1;
            this.loadUserPage();
        }
    }

    editUserRights(userRights: IUserRights) {
        this.modalService.open(
            ChangeUserModalComponent,
            {
                data: {
                    userRights
                }
            }
        ).afterClosed.pipe(
            take(1),
            map(() => {
                this.loadUserPage();
            })).subscribe();
    }

    newUserRights() {
        this.modalService.open(
            ChangeUserModalComponent,
            {
                data: {
                    userRights: undefined
                }
            }
        ).afterClosed.pipe(
            take(1),
            map(() => {
                this.loadUserPage();
            })).subscribe();
    }

    userRightsTrackByFn(index: number, userRights: IUserRights) {
        return userRights.id;
    }
}
